export default {
  init() {
    //
  },

  finalize() {
    window.archiveCollectionsFeaturedGuidesPage = 1;
    jQuery(document).on('click', '.archive-collections-featured-guides__load-more-button', function (){
      window.archiveCollectionsFeaturedGuidesPage += 1;

      jQuery('.archive-collections-featured-guides__load-more-button')
        .attr('disabled', true);

      jQuery.ajax({
        url: window.archiveCollectionsFeaturedGuidesRoute,
        method: 'GET',
        data: {
          p: window.archiveCollectionsFeaturedGuidesPage,
        },
      }).done(function(response){
        jQuery('.archive-collections-featured-guides__load-more-button')
          .attr('disabled', null);

        for (let i = 0; i < response.items.length; i++) {
          jQuery('.archive-collections-featured-guides__items')
            .append('<div class="archive-collections-featured-guides__item">' + response.items[i] + '</div>');
        }

        if (response.items.length < window.archiveCollectionsFeaturedGuidesPostsPerPage) {
          jQuery('.archive-collections-featured-guides__load-more-button')
            .remove();
        }
      });
    });

    window.archiveCollectionsLocationsPage = 1;
    jQuery(document).on('click', '.archive-collections-locations__load-more-button', function (){
      window.archiveCollectionsLocationsPage += 1;

      jQuery('.archive-collections-locations__load-more-button')
        .attr('disabled', true);

      jQuery.ajax({
        url: window.archiveCollectionsLocationsRoute,
        method: 'GET',
        data: {
          p: window.archiveCollectionsLocationsPage,
        },
      }).done(function(response){
        jQuery('.archive-collections-locations__load-more-button')
          .attr('disabled', null);

        for (let i = 0; i < response.items.length; i++) {
          jQuery('.archive-collections-locations__items')
            .append('<div class="archive-collections-locations__item">' + response.items[i] + '</div>');
        }

        if (response.items.length < window.archiveCollectionsLocationsPostsPerPage) {
          jQuery('.archive-collections-locations__load-more-button')
            .remove();
        }
      });
    });
  },
};
